import { addToastMessage } from '../../../js/components/toast';
import { handQueryParams, initPerqButtonsHandler } from '../../../js/components/perq-controller';
import { handleAddToCompare } from '../../../js/api/compare';
import { initAppointment } from '../schedule-appointment/schedule-appointment';
import { shareModal } from '../../../js/components/share-modal';
import { initDNI } from '../../../js/api/dni';

const propertyDetailsEl = document.querySelector('section.property-details');

export const propertyDetails = () => {
  if (propertyDetailsEl) {
    const addToCompareBtn = propertyDetailsEl.querySelector(`#add-to-compare-btn`);
    const propertyAddress = propertyDetailsEl.querySelector('#property-address');
    const printBtn = propertyDetailsEl.querySelector('#print-btn');
    if (addToCompareBtn) {
      addToCompareBtn.addEventListener('click', addToCompareClickHandler);
    }
    if (propertyAddress) {
      propertyAddress.addEventListener('click', addressClickHandler);
    }
    if (printBtn) {
      printBtn.addEventListener('click', printHandler);
    }
    initPerqButtonsHandler(propertyDetailsEl);
    shareModal();
    window.addEventListener('beforeprint', function () {
      beforePrint();
    });
    window.addEventListener('afterprint', function () {
      afterPrint();
    });
  }
}

const beforePrint = () => {
  document.body.classList.add('print-pdp');
}

const afterPrint = () => {
  document.body.classList.remove('print-pdp');
}

const addressClickHandler = (e) => {
  e.preventDefault();
  if (e.currentTarget.innerHTML) {
    window.open(e.currentTarget.href, '_blank');
  }
}

const printHandler = () => {
  window.print();
}

const addToCompareClickHandler = (e) => {
  e.stopPropagation();
  e.preventDefault();
  handleAddToCompare(e)
    .then(() => {
      let body;
      if (e.currentTarget.classList.contains('compared')) {
        body = 'Added to your Compare list';
      } else {
        body = 'Removed from your Compare list';
      }
      addToastMessage({
        body,
      });
    })
}

const dniPhone = document.querySelector('.DCRPhoneHref')
if(dniPhone) initDNI(dniPhone.getAttribute('data-dniId'));



// WEBPACK FOOTER //
// ./src/templates/components/property-details-component/property-details-component.js